import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const deactivateOl = async (id: number) => {
  return restApiClient.url(constructApiUrl(API.ols.deactivate.url, { id })).post()
}
